import { EthiopianDate, DateConverterResult } from '../types';

export default class DateConverter {
  public readonly ethiopianMonths = [
    'መስከረም', 'ጥቅምት', 'ኅዳር', 'ታህሳስ', 'ጥር', 'የካቲት',
    'መጋቢት', 'ሚያዝያ', 'ግንቦት', 'ሰኔ', 'ሐምሌ', 'ነሐሴ', 'ጷጉሜን'
  ];

  private readonly ethiopianDays = [
    'ሰኞ', 'ማክሰኞ', 'ረቡዕ', 'ሐሙስ', 'ዓርብ', 'ቅዳሜ', 'እሑድ'
  ];

  public getMonthName(month: number): string {
    if (month < 1 || month > 13) {
      throw new Error('Invalid month number. Ethiopian months are between 1 and 13.');
    }
    return this.ethiopianMonths[month - 1];
  }

  private jdFromGregorian(date: Date): number {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    const a = Math.floor((14 - month) / 12);
    const y = year + 4800 - a;
    const m = month + 12 * a - 3;

    return day + Math.floor((153 * m + 2) / 5) + 365 * y + Math.floor(y / 4) - Math.floor(y / 100) + Math.floor(y / 400) - 32045;
  }

  private ethiopianFromJD(jd: number): EthiopianDate {
    const r = (jd - 1723856) % 1461;
    const n = r % 365 + 365 * Math.floor(r / 1460);

    const year = 4 * Math.floor((jd - 1723856) / 1461) + Math.floor(r / 365) - Math.floor(r / 1460);
    const month = Math.floor(n / 30) + 1;
    const day = (n % 30) + 1;

    // Calculate day of week (1 = Monday, 7 = Sunday)
    // We add 1 to make Monday = 1, and use % 7 to get the correct index
    const dayOfWeek = ((jd + 1) % 7);
    // Convert to 0-based index for the array
    const dayIndex = dayOfWeek === 0 ? 6 : dayOfWeek - 1;

    return { 
      year, 
      month, 
      day,
      dayOfWeek: this.ethiopianDays[dayIndex]
    };
  }

  private parseDate(dateString: string): Date {
    if (typeof dateString === 'string') {
      const [year, month, day] = dateString.split('-').map(Number);
      return new Date(year, month - 1, day);
    }
    throw new Error('Invalid date format. Please use YYYY-MM-DD format');
  }

  public convertGregorianToEthiopian(gregorianDate: string): DateConverterResult {
    const date = this.parseDate(gregorianDate);
    const jd = this.jdFromGregorian(date);
    const ethiopianDate = this.ethiopianFromJD(jd);
    const formattedDate = `${ethiopianDate.dayOfWeek}፣ ${ethiopianDate.day} ${this.getMonthName(ethiopianDate.month)} ${ethiopianDate.year}`;
    return {
      ethiopianDate,
      formattedDate
    };
  }
}
